import React from "react";
import { Provider } from "react-redux";
import AppRouter from "./routers/AppRouter";
import { store } from "./store/configureStore";
import LoadingPage from "./components/LoadingPage";
import { startLogin } from "./actions/auth";
import HttpsRedirect from "react-https-redirect";
import "./styles/base/app.scss";

class App extends React.Component {


  componentDidMount(){
	this.setState({
		impersonate: localStorage.getItem("impersonate")
	}) 
  }

//   componentDidUpdate(){
// 	this.setState({
// 		impersonate: localStorage.getItem("impersonate")
// 	})
//   }

  constructor(props) {
    super(props);

    this.state = {
      jsx: <LoadingPage />,
	  impersonate: localStorage.getItem("impersonate")
    };
  }
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("auth");

    const user = JSON.parse(localStorage.getItem("user"));
    if (user && !window.location.pathname.includes("impersonate")) {
      store.dispatch(startLogin(undefined, undefined, user.token)).then(() => {
        this.setState(() => ({
          jsx: <AppRouter />
        }));
      });
    } else if (token) {
      store.dispatch(startLogin(undefined, undefined, token)).then(() => {
        this.setState(() => ({
          jsx: <AppRouter />
        }));
      });
    } else {
      this.setState(() => ({
        jsx: <AppRouter />
      }));
    }
  }
  render() {
	const style = this.state.impersonate === "true" ? {
		border: "2px solid red",height: "100dvh",
	}:{height: "100dvh"}
    return (
		<div style={style}>
        {process.env.NODE_ENV === "development" ? (
			<Provider store={store}>{this.state.jsx}</Provider>
			) : (
			<HttpsRedirect>
				<Provider store={store}>{this.state.jsx}</Provider>
			</HttpsRedirect>
        )}
      </div>
    );
  }
}

export default App;
